import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "colors"
    }}>{`Colors`}</h1>
    <p>{`Below are color classes that are used internally for [`}{`[SolidColor]`}{`]. `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./cmykcolor.md"
        }}>{`CMYKColor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./graycolor.md"
        }}>{`GrayColor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./hsbcolor.md"
        }}>{`HSBColor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./labcolor.md"
        }}>{`LabColor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./nocolor.md"
        }}>{`NoColor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./rgbcolor.md"
        }}>{`RGBColor`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      